"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** *******************************************************************************************************************
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  
  Licensed under the Apache License, Version 2.0 (the "License").
  You may not use this file except in compliance with the License.
  You may obtain a copy of the License at
  
      http://www.apache.org/licenses/LICENSE-2.0
  
  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.                                                                              *
 ******************************************************************************************************************** */
const react_1 = __importDefault(require("react"));
const Box_1 = __importDefault(require("../../layouts/Box"));
const Heading_1 = __importDefault(require("../Heading"));
/** A heading that spans the full width of its container */
const HeadingStripe = ({ title, actionButtons }) => {
    return (react_1.default.createElement(Box_1.default, { width: "100%", display: "flex" },
        react_1.default.createElement(Box_1.default, { flexGrow: "1" },
            react_1.default.createElement(Heading_1.default, { variant: "h1" }, title)),
        actionButtons && react_1.default.createElement(Box_1.default, null, actionButtons)));
};
exports.default = HeadingStripe;
//# sourceMappingURL=index.js.map